<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M11.2349 11.6514C11.5603 11.326 11.5603 10.7983 11.2349 10.4729L9.76172 8.99973L11.2349 7.52657C11.5603 7.20116 11.5603 6.67352 11.2349 6.34809C10.9095 6.02264 10.3818 6.02264 10.0564 6.34809L8.58323 7.82124L7.11008 6.34809C6.78465 6.02265 6.25701 6.02265 5.93158 6.34809C5.60614 6.67353 5.60614 7.20116 5.93158 7.52657L7.40473 8.99973L5.93158 10.4729C5.60614 10.7983 5.60614 11.326 5.93158 11.6514C6.25701 11.9768 6.78465 11.9768 7.11008 11.6514L8.58323 10.1782L10.0564 11.6514C10.3818 11.9768 10.9095 11.9768 11.2349 11.6514Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.0431 3.04261C6.21125 -0.125532 11.3478 -0.125532 14.516 3.04261C17.4852 6.01182 17.6717 10.71 15.0753 13.8963L17.0896 15.9106C17.415 16.236 17.415 16.7637 17.0896 17.0891C16.7642 17.4145 16.2365 17.4145 15.9111 17.0891L13.8968 15.0748C10.7105 17.6712 6.01231 17.4847 3.0431 14.5155C-0.125043 11.3473 -0.125043 6.21076 3.0431 3.04261ZM13.3375 4.22113C10.8202 1.70385 6.73889 1.70385 4.22162 4.22113C1.70434 6.7384 1.70434 10.8197 4.22162 13.337C6.73889 15.8543 10.8202 15.8543 13.3375 13.337C15.8547 10.8197 15.8547 6.7384 13.3375 4.22113Z"
      fill="currentColor"
    />
  </svg>
</template>